import { useMemo } from 'react'
import { Permissions } from '@wove/common/permissions'
import useUserStore from '@src/state/user'

interface UseRequiredPermissionsOptions {
  requireAll?: boolean
}

export const useRequiredPermissions = (
  requiredPermissions: Permissions[], 
  options: UseRequiredPermissionsOptions = {}
) => {
  const { requireAll = true } = options
  const user = useUserStore((state) => state.user)
  const permissions = useUserStore((state) => state.permissions)
  
  const userPermissions = useMemo(() => {
    return permissions.map(p => p as Permissions)
  }, [permissions])

  const hasPermission = useMemo(() => {
    if (!user) return false
    
    return requireAll
      ? requiredPermissions.every(permission => userPermissions.includes(permission))
      : requiredPermissions.some(permission => userPermissions.includes(permission))
  }, [user, userPermissions, requiredPermissions, requireAll])

  const hasSpecificPermission = (permission: Permissions) => {
    return userPermissions.includes(permission)
  }

  return {
    hasPermission,
    hasSpecificPermission,
    userPermissions,
    isLoading: !user && useUserStore.getState().authed === false,
  }
}